export type NotificacaoType =
  | "sono"
  | "mamada"
  | "sono_noturno"
  | "sono_noturno_atrasado"
  | "falta"
  | "disciplina"
  | "soneca_curta"
  | "despertar_frequente"
  | "parabens"
  | "reminder"
  | "soneca"
  | 'soneca_atrasada'
  | 'mamada_atrasada'

// Pode exportar o array se quiser para ordenar
export const ordemTiposNotificacao: NotificacaoType[] = [
  'mamada_atrasada',
  'soneca_atrasada',
  "sono_noturno_atrasado",
  "sono",
  "mamada",
  "sono_noturno",
  "soneca",
  "falta",
  "disciplina",
  "soneca_curta",
  "despertar_frequente"
];
